// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__5IKRr","savePackageButton":"ClientWallet_savePackageButton__2-baN"};